import en from "commonAssets/i18n/en";
import { merge } from "lodash";

const overrides = {
    nav_submit_claim_button: "Fix Claim",
    confirmation_screen_additional: {
        title: "Notice",
        body: '<p class="fw-bold">You will receive a confirmation and copy of your claim via email, including your Submitted Claim ID and Confirmation Code. Do not share your Claim ID or Confirmation Code with others. We will never call you for this information.</p><p>You may also print this screen for your records.</p><p>If you don\'t receive a confirmation email after 3 days, please check your spam folder.</p>',
    },
};

export default { en: merge(en, overrides) };
